import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faGavel, faCoins, faBook, faScaleBalanced, faReceipt } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function ControleLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const nome = localStorage.getItem('nome');

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        console.log(user)
        switch (user) {
            case "Administrador":
                setDirect('/restrito')
                break;
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect("/restrito/licitacao")
                break;
            case "Controle Interno":
                await setDirect(false)
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={3}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faShop} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Licitações</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/lrf')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faCoins} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de LRF</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
            
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/balanco')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faScaleBalanced} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Balanços</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faReceipt} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Contas Públicas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default ControleLoggedScreen;